import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const ROUTE_LABELS = {
  "/": "Koti",
  "/vuokrattavat": "Vuokrattavat",
  "/meista": "Meistä",
  "/ukk": "UKK",
  "/tee-varaus": "Tee varaus",
};

export default function BreadcrumbsHelmet() {
  const location = useLocation();
  const pathParts = location.pathname.split("/").filter(Boolean);

  const items = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Koti",
      item: "https://spiderlegsproductions.com/",
    },
  ];

  let currentPath = "";

  pathParts.forEach((part) => {
    currentPath += `/${part}`;
    const label = ROUTE_LABELS[currentPath];
    if (!label) return;

    items.push({
      "@type": "ListItem",
      position: items.length + 1,
      name: label,
      item: `https://spiderlegsproductions.com${currentPath}`,
    });
  });

  if (items.length <= 1) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: items,
        })}
      </script>
    </Helmet>
  );
}
